import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';
import { Subject } from 'rxjs';

import { SessionTokenService } from '../../../session/service/session-token';
import { HttpConfig } from '../../http/config';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Md5Service } from './md5-service';

export interface IUploadOptions {
  url: string;
  relatedTo: string;
  type: string;
  aspectRatio?: string;
  onCompleteItem: (item: File, response: string) => void;
}

@Injectable()
export class UploadFactory {

  constructor(private sessionTokenService: SessionTokenService,
              private httpConfig: HttpConfig,
              private httpClient: HttpClient,
              private httpBackend: HttpBackend,
              private toastrService: ToastrService) {
  }

  public factory(options: IUploadOptions): UploadService {
    const service = new UploadService(
      this.sessionTokenService,
      this.httpConfig,
      this.httpClient,
      this.httpBackend,
      this.toastrService,
    );
    service.initialize(options);

    return service;
  }
}

interface PreUploadResponse {
  signature: string;
  file: string;
  signedUrl: string;
}

export class UploadService {

  public progress: number = 0;
  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;
  public channel: Subject<any> = new Subject<any>();
  preUploadResponse: PreUploadResponse;
  fileExtension: string;
  options: IUploadOptions;
  uploadElRef: HTMLInputElement;
  httpClientClean: HttpClient;

  constructor(private sessionTokenService: SessionTokenService,
              private httpConfig: HttpConfig,
              private httpClient: HttpClient,
              private httpBackend: HttpBackend,
              private toastrService: ToastrService) {
    this.httpClientClean = new HttpClient(this.httpBackend);
  }

  public initialize(options: IUploadOptions): void {
    this.options = options;
    this.uploader = new FileUploader({
      removeAfterUpload: true,
      disableMultipart: true,
    });

    this.uploader.onProgressAll = (progress: any) => {
      this.progress = progress;
    };
    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.progress = 0;
    };
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      // const error = JSON.parse(response);
      this.toastrService.error( 'Upload failed');
      // this.uploader.removeFromQueue(item);
      // this.uploader.cancelItem(item);
    };
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileDropped(e: any): void {
    this.uploader.uploadAll();
  }

  public fileSelected(e: any, ref: HTMLInputElement): void {
    this.uploadElRef = ref;
    const file = ref.files[0];
    const ext = file.name.split('.').pop();
    this.httpClient.post(this.options.url, {
      extension: ext
    }).subscribe((response: any) => {
      this.preUploadResponse = <PreUploadResponse>response;
      this.fileExtension = ext;
      console.log('response', response);
      this.httpClientClean.put(this.preUploadResponse.signedUrl, ref.files[0])
        .subscribe(() => {
          Md5Service.compute(file).then((md5sum: string) => {
            this.httpClient.put(this.options.url,  {
              signature: this.preUploadResponse.signature,
              file: this.preUploadResponse.file,
              fileType: this.options.type,
              relatedTo: this.options.relatedTo,
              extension: this.fileExtension,
              md5sum
            }).subscribe(() => {
              if (typeof this.options.onCompleteItem === 'function') {
                this.options.onCompleteItem(file, response);
              }
            });
          }).catch(err => {
            console.log('upload error', err);
          });
        });
    });
  }

  public clearQueue(): void {
    this.uploader.clearQueue();
  }
}
